import React, { useCallback, useEffect, useState } from 'react'
import { Calendar } from 'react-big-calendar'
import { useSelector, useDispatch } from 'react-redux'
import dayjs from 'dayjs'
import config from 'config'
import ViewMixrPopin from 'srcReact/components/popinsContent/ViewMixrPopin'
import Toolbar from './components/Toolbar'
import MonthlyEvent from './components/MonthlyEvent'
import CommonEvent from './components/CommonEvent'
import { isMobileScreen } from 'srcReact/helpers/utils'
import history from 'srcReact/helpers/history'
import { calendarActions } from 'srcReact/CalendarPage/action'
import styles from './styles.module.scss'
import dayjsLocalizer from 'srcReact/helpers/dayjsLocalizer'
import { appConstantSettings } from 'srcReact/appConstantSettings'

export default function EventCalendar({ handleNavigate, currentView, setCurrentView }) {
  const localizer = dayjsLocalizer(dayjs)
  const dispatch = useDispatch()
  const {
    common: { isNative },
    calendarEvents: {
      selectedEvent,
      refreshMyCalendar,
      myCalendar: { events, monthlyEvents }
    }
  } = useSelector((state) => state)
  const [isMobile, setIsMobile] = useState(isMobileScreen())
  const [showViewModal, setShowViewModal] = useState(false)
  useEffect(() => {
    window.scrollTo(0, 0)
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])
  useEffect(() => {
    if (selectedEvent.user_attending_type === 'can_t_go') {
      setShowViewModal(false)
    }
  }, [refreshMyCalendar])

  const handleWindowSizeChange = () => {
    setIsMobile(isMobileScreen())
  }

  const handleCurrentView = (view) => {
    setCurrentView(view)
  }

  const eventStyleGetter = (event, start, end, isSelected) => {
    let commonStyle = {
      backgroundColor: 'transparent',
      border: 'none',
      padding: '0px'
    }
    let monthlyStyle = {
      backgroundColor: 'transparent',
      border: 'none'
    }
    return {
      style: currentView === 'month' ? monthlyStyle : commonStyle
    }
  }

  const customSlotPropGetter = () => {
    return {
      className: styles.slot
    }
  }

  const resetScroll = async () => {
    setShowViewModal(false)
  }

  const handleViewMixrPopin = (event) => {
    if (currentView !== 'month') {
      dispatch(calendarActions.setSelectedEvent(event))
      setShowViewModal(true)
    }
  }

  const handleViewMixr = async () => {
    await resetScroll()
    //nativeapp
    if (isNative) {
      window.location = config.webUrl + `/0/home/event/${selectedEvent.mixr_id}?backNavigation=true`
      return
    }
    history.push(`/0/home/event/${selectedEvent.mixr_id}`, { backNavigation: true })
  }

  const renderViewMixrPopin = (
    <ViewMixrPopin
      mixrId={selectedEvent.mixr_id}
      title={selectedEvent.title}
      picture={selectedEvent.mixr_picture}
      startDate={selectedEvent.event_utc_start_datetime}
      endDate={selectedEvent.event_utc_end_datetime}
      utcOffset={selectedEvent.event_utc_offset}
      timezone={selectedEvent.timezone}
      description={selectedEvent.mixr_description}
      color={
        selectedEvent.is_over
          ? 'gray'
          : selectedEvent.mixr_color
          ? selectedEvent.mixr_color
          : appConstantSettings.DEFAULT_COLOR.name
      }
      isRecurrence={selectedEvent.recurrence_type === 'recurring'}
      isInvited={selectedEvent.is_invited === 1}
      attendance={selectedEvent.mixr_attending_type}
      isVisibility={selectedEvent.group_visibility !== 'public'}
      userAttendance={selectedEvent.user_attending_type}
      location={selectedEvent.display_address}
      showViewMixr={showViewModal}
      closeViewMixr={() => setShowViewModal(false)}
      handleClick={handleViewMixr}
      menuPortalTarget={false}
      isMixrOver={selectedEvent.is_over}
      group={{ id: selectedEvent.group_id, name: selectedEvent.group_title, role: selectedEvent.role_group }}
      mixrRole={selectedEvent.role_mixr}
      withoutGroupApproval={selectedEvent.without_group_approval}
    />
  )

  const onView = useCallback((newView) => setCurrentView(newView), [setCurrentView])

  const onShowMore = (events, date) => {
    window.scrollTo(0, 0)
    setTimeout(() => handleNavigate(date, 'day'), 10000)
  }
  const currenViewHeight = isNative ? '100vh' : currentView !== 'month' ? 'calc(100vh - 10.6rem)' : '100vh'
  const eventsList = currentView === 'month' ? monthlyEvents : events

  return (
    <React.Fragment>
      <Calendar
        localizer={localizer}
        events={eventsList}
        style={{
          height: currenViewHeight,
          width: '100%',
          backgroundColor: 'white',
          paddingTop: '1rem',
          paddingBottom: '1rem',
          borderTopLeftRadius: isMobile ? '1.25rem' : '0.75rem',
          borderTopRightRadius: isMobile ? '1.25rem' : '2rem',
          borderBottomLeftRadius: isMobile ? '0px' : '2rem',
          borderBottomRightRadius: isMobile ? '0px' : '0.75rem',
          boxShadow: '0 -8px 16px 0 rgba(96, 97, 112, 0.16), 0 2px 4px 0 rgba(40, 41, 61, 0.04)'
        }}
        onView={onView}
        defaultView={currentView}
        onSelectEvent={handleViewMixrPopin}
        eventPropGetter={eventStyleGetter}
        slotPropGetter={customSlotPropGetter}
        onNavigate={handleNavigate}
        doShowMoreDrillDown={true}
        onShowMore={onShowMore}
        scrollToTime={new Date()}
        components={{
          day: {
            event: CommonEvent
          },
          week: {
            event: CommonEvent
          },
          month: {
            event: MonthlyEvent
          },
          toolbar: (props) => (
            <Toolbar {...props} handleCurrentView={handleCurrentView} handleNavigate={handleNavigate} />
          ),
          timeGutter: (props) => <TimeGutter {...props} date={selectedEvent.event_utc_start_datetime} />
        }}
      />
      {renderViewMixrPopin}
    </React.Fragment>
  )
}
